<app-page-title icon="fa-plug" title="SMS via Integração" data-testid="integration-sms-section">
</app-page-title>

<form (submit)="list()">
  <div class="row col-md-12">
    <div class="col-md-12 col-sm-12" style="width: fit-content">
      <mat-form-field>
        <mat-label>Data inicial</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="startedMonth" name="startedMonth" />
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-12 col-sm-12" style="width: fit-content">
      <mat-form-field>
        <mat-label>Data final</mat-label>
        <input matInput [matDatepicker]="picker2" [(ngModel)]="endedMonth" name="endedMonth" />
        <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
        <mat-datepicker #picker2></mat-datepicker>
      </mat-form-field>
    </div>
    <div class="col-md-12 col-sm-12 d-flex align-items-center" style="width: fit-content">
      <!--
        Sem `(click)`: o botão é `type="submit"` DENTRO do form, então o clique já
        dispara o `(submit)` acima. Ter os dois fazia cada clique buscar duas
        vezes — duas requisições idênticas por busca.
      -->
      <button class="btn btn-primary" type="submit" [disabled]="invalidPeriod" data-testid="btn-search">
        <i class="fa fa-search"></i>
      </button>
    </div>
  </div>

  <!--
    UMA mensagem para o par de datas, não uma em cada `mat-form-field`: o erro é
    da RELAÇÃO entre elas, e repetir o mesmo texto duas vezes lado a lado sugere
    dois problemas distintos. O botão fica desabilitado junto — antes o aviso era
    só decorativo, a busca saía do mesmo jeito com o intervalo invertido e
    voltava vazia, o que o operador lê como "não há envios".
  -->
  <div class="row col-md-12" *ngIf="invalidPeriod">
    <small class="text text-danger" data-testid="invalid-period">
      Período inválido: a data inicial é posterior à final.
    </small>
  </div>
</form>

<app-skeleton *ngIf="loading" variant="table-row" [count]="5" [columns]="5"
  label="Carregando as integrações" data-testid="integrations-loading"></app-skeleton>

<div *ngIf="!loading && integrations.length > 0; else notFound" data-testid="integrations-list">
  <div
    class="card integration-card mb-3"
    *ngFor="let integration of integrations"
    (click)="open(integration)"
    data-testid="integration-item"
  >
    <div class="row align-items-center">
      <div class="col-md-4 col-sm-12 d-flex align-items-center">
        <i class="fa fa-plug integration-icon"></i>
        <div>
          <h4 class="integration-name" data-testid="integration-name">{{ integration.name }}</h4>
          <small>Última atividade: {{ integration.last_activity_at | date : "dd/MM/yyyy, H:mm" }}</small>
        </div>
      </div>
      <div class="col-md-2 col-sm-4">
        <label>Automações</label>
        <p data-testid="integration-automations-count">{{ integration.total_automations }}</p>
      </div>
      <div class="col-md-2 col-sm-4">
        <label>Mensagens</label>
        <p>{{ integration.total_sends | numberFormat }}</p>
      </div>
      <div class="col-md-2 col-sm-4">
        <label>Enviadas</label>
        <p>{{ integration.total_sent | numberFormat }}</p>
      </div>
      <div class="col-md-2 col-sm-12 text-right">
        <a class="btn btn-secondary" [routerLink]="['/integration-sms/view', integration.id]">
          <i class="fa fa-search"></i>
        </a>
      </div>
    </div>
  </div>
</div>

<ng-template #notFound>
  <div class="card" *ngIf="!loading">
    <div class="col" data-testid="no-integrations">
      Nenhuma integração com envios no período.
    </div>
  </div>
</ng-template>
